import './footer.scss';

function Footer() {
  return (
    <div className='footer'>
      <span>All rights reserved.</span>
      <span>©Oldkent Shisha</span>
    </div>
  )
}

export default Footer